export default "__VITE_ASSET__eMahqxZ2__"